export default __webpack_public_path__ + "static/media/20.7a88cc09.jpeg";